module.exports = __webpack_public_path__ + "static/img/sigla_guv_coroana_gri.8b30e56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/link-logo/sigla_guv_coroana_gri.png
// module id = KQ/Q
// module chunks = 1